'use es6';

export var PREVIEW_DOMAINS = {
  local: 'local.hubspotqa.com',
  prod: 'preview.hs-sites.com',
  qa: 'preview.hs-sitesqa.com'
};